import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import ListItem from "@material-ui/core/ListItem";

import { useStyles } from "../../../../../Components/CSS/DetailStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ViewIssuedBook from "../../IssuedBook/ViewIssuedBook/ViewIssuedBook";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class BookDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookDetails: {},
      issuedData: [],
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getBookDetails(this.props.match.params.id);
    }
  }

  getBookDetails = async (bookId) => {
    try {
      const response = await Axios.get(`${url}/api/books/${bookId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.book) {
        this.setState({
          bookDetails: response.data.book,
          issuedData: response.data.book.loans ? response.data.book.loans : [],
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getBookDetails(bookId);
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { bookDetails } = this.state;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Book Details" refreshUrl={this.props.match.url} />
          {bookDetails && (
            <div className={classes.listitemRoot}>
              <div className={classes.listitemContent}>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Book Title</b>
                  <div>{bookDetails.title}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Number Of Copies Available</b>
                  <div>{bookDetails.numberOfCopies}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>ISBN</b>
                  <div>{bookDetails.ISBN}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Category</b>
                  <div>
                    {bookDetails.category ? bookDetails.category : "N/A"}
                  </div>
                </ListItem>
              </div>
              <div className={classes.listitemContent}>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Publication</b>
                  <div>{bookDetails.publication}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Current Available Copies</b>
                  <div>{bookDetails.currentStock}</div>
                </ListItem>
                <ListItem divider>
                  <b style={{ flexGrow: 1 }}>Author</b>
                  <div>{bookDetails.author}</div>
                </ListItem>
              </div>
            </div>
          )}
          <br />
          <div style={{ fontSize: 20, fontWeight: "bold" }}>
            Issued and Return Data
          </div>
          <ViewIssuedBook
            bookId={this.props.match.params.id}
            getBookDetails={this.getBookDetails}
            bookDetails={this.state.bookDetails}
            issuedData={this.state.issuedData}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(BookDetails)));
